import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import MDTypography from "components/MDTypography";
import { apiGetInboisDetailByNoInbois } from "api/inbois_detail";
import { apiGetInboisByNoInbois } from "api/inbois";
import { buttonStyles } from "utils/buttonStyles";
import { dialogHeaderStyles, dialogContentStyles } from "utils/dialogStyles";

function ViewInboisPelbagai({ open, onClose, noInbois }) {
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const [error, setError] = useState("");
  const [tarikhInbois, setTarikhInbois] = useState("");

  useEffect(() => {
    if (open && noInbois) {
      setLoading(true);
      setError("");
      Promise.all([apiGetInboisDetailByNoInbois(noInbois), apiGetInboisByNoInbois(noInbois)])
        .then(([detailRes, inboisRes]) => {
          setDetails(detailRes.data || []);
          const tarikh = inboisRes.data?.tarikh_inbois;
          setTarikhInbois(tarikh ? new Date(tarikh).toLocaleDateString("en-GB") : "");
        })
        .catch(() => {
          setError("Gagal memuatkan butiran inbois.");
          setDetails([]);
          setTarikhInbois("");
        })
        .finally(() => setLoading(false));
    } else if (!open) {
      setDetails([]);
      setError("");
      setTarikhInbois("");
    }
  }, [open, noInbois]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ ...dialogHeaderStyles.warning, fontWeight: 600 }}>
        Inbois Pelbagai
      </DialogTitle>
      <DialogContent sx={{ ...dialogContentStyles.default, minHeight: 320 }}>
        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2, mt: 2 }}>
          <Grid item xs={6} md={6} lg={6}>
            <MDTypography variant="caption" fontWeight="bold" sx={{ mr: 1 }}>
              Tarikh Inbois:
            </MDTypography>
            <MDTypography
              variant="overline"
              fontWeight="bold"
              color={tarikhInbois ? "primary" : "info"}
            >
              {tarikhInbois || "-"}
            </MDTypography>
          </Grid>
          <Grid
            item
            xs={6}
            md={6}
            lg={6}
            sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
          >
            <MDTypography variant="caption" fontWeight="bold" sx={{ mr: 1 }}>
              No Inbois:
            </MDTypography>
            <MDTypography
              variant="overline"
              fontWeight="bold"
              color={noInbois ? "primary" : "error"}
            >
              {noInbois || "-"}
            </MDTypography>
          </Grid>
        </Grid>
        {error && <MDTypography color="error">{error}</MDTypography>}
        {loading ? (
          <MDTypography>Memuatkan...</MDTypography>
        ) : (
          <TableContainer component={Paper} sx={{ boxShadow: "none", border: "1px solid #eee" }}>
            <Table size="small">
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                <TableCell align="center">
                  <MDTypography variant="caption" fontWeight="bold">
                    Bil.
                  </MDTypography>
                </TableCell>
                <TableCell align="center">
                  <MDTypography variant="caption" fontWeight="bold">
                    Butiran
                  </MDTypography>
                </TableCell>
                <TableCell align="center">
                  <MDTypography variant="caption" fontWeight="bold">
                    Kuantiti
                  </MDTypography>
                </TableCell>
                <TableCell align="center">
                  <MDTypography variant="caption" fontWeight="bold">
                    Kadar
                  </MDTypography>
                </TableCell>
                <TableCell align="center">
                  <MDTypography variant="caption" fontWeight="bold">
                    Jumlah
                  </MDTypography>
                </TableCell>
              </TableRow>
              <TableBody>
                {details.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center" sx={{ color: "#888" }}>
                      Tiada item.
                    </TableCell>
                  </TableRow>
                ) : (
                  details.map((row, idx) => (
                    <TableRow key={row.id} hover>
                      <TableCell align="center">
                        <MDTypography variant="caption" fontWeight="regular">
                          {idx + 1}
                        </MDTypography>
                      </TableCell>
                      <TableCell align="left">
                        <MDTypography variant="caption" fontWeight="regular">
                          {row.butiran}
                        </MDTypography>
                      </TableCell>
                      <TableCell align="center">
                        <MDTypography variant="caption" fontWeight="regular">
                          {row.kuantiti}
                        </MDTypography>
                      </TableCell>
                      <TableCell align="center">
                        <MDTypography variant="caption" fontWeight="regular">
                          {row.kadar}
                        </MDTypography>
                      </TableCell>
                      <TableCell align="center">
                        <MDTypography variant="caption" fontWeight="regular">
                          {row.jumlah}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions sx={dialogContentStyles.default}>
        <Grid container justifyContent="flex-end">
          <Button
            onClick={onClose}
            variant="contained"
            size="small"
            sx={buttonStyles.cancel}
          >
            TUTUP
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

ViewInboisPelbagai.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  noInbois: PropTypes.string,
};

export default ViewInboisPelbagai;
